import routerOptions0 from "/usr/src/app/content/n3-spas-1ae1ee22-fd3e-40fb-8833-1fa9b0c93c78/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}